export interface INotification {
  id: string
  title?: string | null
  message: string
  type?: 'default' | 'error' | 'warning' | 'success'
  hint?: string
  delay?: number | null
}

const DELAY_OF_NOTIFICATION = 4000

function getNotificationMessageDedupeKey(message: string): string {
  return message.trim()
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Array<INotification>>([])

  const titleMap: Record<Required<INotification>['type'], string> = {
    default: 'Уведомление',
    error: 'Ошибка',
    warning: 'Внимание',
    success: 'Успешно',
  }

  function notify(data: Omit<INotification, 'id'>) {
    const type = data.type ?? 'default'
    const delay = data.delay === undefined ? DELAY_OF_NOTIFICATION : data.delay
    const title = data.title === undefined ? titleMap[type] : data.title

    const dedupeKey = getNotificationMessageDedupeKey(data.message)
    if (notifications.value.some(n => getNotificationMessageDedupeKey(n.message) === dedupeKey)) {
      return
    }

    const id = Math.random().toString(36).slice(2)

    notifications.value.push({ id, title, message: data.message, type, delay, hint: data.hint })

    if (delay) {
      setTimeout(() => {
        close(id)
      }, delay)
    }
  }

  function close(id: string) {
    notifications.value = notifications.value.filter(
      notification => notification.id !== id,
    )
  }

  return {
    notifications,
    notify,
    close,
  }
})
